import { Locale } from '@ps-smart-cp/ppfw-client';

const treatmentAfterExpirationConfig = {
  reLease: new Map([[Locale.ja, '再リース']]),
  giveBack: new Map([[Locale.ja, '返却']]),
  purchase: new Map([[Locale.ja, '購入']]),
  discard: new Map([[Locale.ja, '廃棄']]),
};

export { treatmentAfterExpirationConfig };
